import { render, staticRenderFns } from "./MyDevelop.vue?vue&type=template&id=0acbf95e&scoped=true"
import script from "./MyDevelop.vue?vue&type=script&lang=js"
export * from "./MyDevelop.vue?vue&type=script&lang=js"
import style0 from "./MyDevelop.vue?vue&type=style&index=0&id=0acbf95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbf95e",
  null
  
)

export default component.exports